// extracted by mini-css-extract-plugin
export default {"title":"lqZhmDujSz9pi3RWEU2l"};